const types = {
  ADD: 'app/notifications/ADD',
  CLEAR: 'app/notifications/CLEAR',
};

export default types;
